import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Day from './Day';
import Month from './Month';
import Year from './Year';

export default function Date({
  id,
  label,
  day,
  month,
  year,
  isValid,
  onChange,
  required,
}) {
  return (
    <>
      <Row className="mb-3">
        <Form.Label column sm={6} className="primary-label">
          {label}
        </Form.Label>
        <Col sm={6}>
          <Row className="mb-0">
            <Month
              controlId={id + 'Month'}
              defaultValue={month}
              isValid={isValid}
              required={required}
              onChange={onChange}
            />
            <Day
              controlId={id + 'Day'}
              defaultValue={day}
              isValid={isValid}
              required={required}
              onChange={onChange}
            />
            <Year
              controlId={id + 'Year'}
              defaultValue={year}
              isValid={isValid}
              required={required}
              onChange={onChange}
            />
          </Row>
        </Col>
      </Row>
    </>
  );
}
